module.exports = __webpack_public_path__ + "static/media/txt.28cbce52.svg";